import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgZapIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	fill: "none",
	role: "img",
	"aria-label": "OWASP ZAP",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 32,
		height: 32,
		rx: 7,
		fill: "#00A29A"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M17 5 8 19h6l-2 8 10-14h-7l4-8z",
		fill: "#FFFFFF"
	})]
});
export default SvgZapIcon;
